<template lang="">
  <div class="cardContentT">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index, item)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="chart" ref="pieChart" />
  </div>
</template>

<script>
import { loadChart } from "../chart/chartData";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      pieChart: null,
      active: 0,
      typeList: ["数量", "资金"]
    };
  },
  mounted() {
    this.initChart();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    },
    initChart() {
      this.pieChart = this.$echarts.init(this.$refs.pieChart);
      const bfData = [
        [
          {
            name: "贷款贴息",
            value: 11
          },
          {
            name: "农业设施",
            value: 20
          },
          {
            name: "科技与信息支撑",
            value: 10
          },
          {
            name: "产业融合",
            value: 1
          },
          {
            name: "土地流转",
            value: 10
          },
          {
            name: "公共区域品牌",
            value: 10
          },
          {
            name: "其它",
            value: 5
          }
        ],
        [
          {
            name: "贷款贴息",
            value: 20
          },
          {
            name: "农业设施",
            value: 10
          },
          {
            name: "科技与信息支撑",
            value: 30
          },
          {
            name: "产业融合",
            value: 10
          },
          {
            name: "土地流转",
            value: 10
          },
          {
            name: "公共区域品牌",
            value: 20
          },
          {
            name: "其它",
            value: 10
          }
        ]
      ];
      const unitArr = ["个", "万元"];
      const seriesData = bfData[this.active];
      const unit = unitArr[this.active];
      const legendData = [
        "贷款贴息",
        "农业设施",
        "科技与信息支撑",
        "产业融合",
        "土地流转",
        "公共区域品牌",
        "其它"
      ];
      loadChart(this.pieChart, seriesData, legendData, unit);
      window.addEventListener("resize", () => {
        this.pieChart.resize();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContentT
  height 100%
  .chart
    height 100%
.tab-box
  position absolute
  top 60px
  right 4%
  z-index 999
  .tab-item
    color #fff
    font-size 10px
    padding-left 13px
    margin-right 50px
    position relative
    cursor pointer
    &:before
      content ' '
      width 24px
      height 14px
      border-radius 2px
      background #fff
      position absolute
      right 75%
      top 50%
      transform translateY(-50%)
  .tab-item:last-child
    margin-right 0
  .active
    color #0e9cff
    &:before
      background #0e9cff
</style>
